<div class="landing-container">
  <div class="main-container">
    <div class="content">
      <img class="landing-img" src="assets/e-order/landing-image.svg" alt="image" loading="lazy" />
      <div class="landing-content">
        <div class="header">
          <img class="logo" src="assets/zeoniq-logo.svg" alt="image" loading="lazy" />
          <span class="title">Zeoniq e-Order</span>
        </div>

        <div class="content-1">
          Ordering to Rewards - all in 1 place
        </div>

        <div class="content-2">
          Everything from food orders to rewards & <br>membership - right at your fingertips!
        </div>

        <div class="dashed-line"></div>

        <div class="content-3">
          Have a question? Reach us at:<br>
          <a class="email-link" href="mailto:info@zeoniq.com">eOrder@zeoniq.com</a>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="column-1">
        <img class="logo" src="assets/zeoniq-logo.svg" alt="image" loading="lazy" />
        <div class="version">Zeoniq e-order {{version}}</div>
      </div>
      <div class="column-2">
        <div class="text" (click)="onNavigate('tnc')">Terms</div>
        <div class="text" (click)="onNavigate('privacyPolicy')">Privacy Policy</div>
      </div>
    </div>
  </div>
</div>